import { StateCreator } from 'zustand';
import { storeResetFns } from '.';

type State = {
	isLoading: boolean;
};

type Actions = {
	setIsLoading: (value: boolean) => void;
};

export type LoaderState = State & Actions;

const initialState = {
	isLoading: false,
};

export const createLoaderSlice: StateCreator<LoaderState> = set => {
	storeResetFns.add(() => {
		set(initialState);
	});

	return {
		...initialState,
		setIsLoading: value => {
			set({
				isLoading: value,
			});
		},
	};
};
